import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Container, Row } from 'reactstrap';
import { connect } from '../../actions/atorch';
import locals from './index.scss';
import { PrintReport } from './PrintReport';
export const AtorchConsole = () => {
    const dispatch = useDispatch();
    const connected = useSelector((state) => state.report.connected);
    const latest = useSelector((state) => state.report.latest);
    const onConnect = () => dispatch(connect());
    return (React.createElement(Container, { className: locals.container },
        React.createElement(Row, { className: 'ml-2 justify-content-center' },
            React.createElement(Button, { outline: true, onClick: onConnect }, connected ? 'Disconnect' : 'Connect')),
        React.createElement(PrintReport, { packet: latest })));
};
